// extracted by mini-css-extract-plugin
export default {"additional":"ZoneOverviewDelegations_additional__uY61P"};